const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const SalesExecutive = 'SalesExecutive'
const Financial = "Financial"
const Logistics = 'Logistics'

export default [
  {
    path: '/pickup_locations/create',
    name: 'CreatePickupLocation',
    component: () => import('@/_backoffice/_registrations/components/pickup_locations/CreatePickupLocation.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, Logistics],
    },
  },
  {
    path: '/pickup_locations',
    name: 'PickupLocations',
    component: () => import('@/_backoffice/_registrations/components/pickup_locations/PickupLocations.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, Logistics],
    },
    children:[
      {
        path: ':id',
        name: 'ShowPickupLocation',
        component: () => import('@/_backoffice/_registrations/components/pickup_locations/ShowPickupLocation.vue'),
        meta: {
          auth: true,
          roles: [Director, SalesExecutive, Manager, Logistics]
        },
        
      },
    ]
  },



]